import { Injectable } from "@angular/core";
import { Platform } from "@ionic/angular";
import { BehaviorSubject, Subject, fromEvent } from "rxjs";
import { CasinoGameModel } from "src/app/models/casino-game.model";
import { CustomerModel } from "src/app/models/customer-model";
import { isUndefined } from "../codeUtils";
import { ConfigService } from "../config/config.service";
import { EventsService } from "../event/event.service";
import { GameHub } from "./game-hub";
import { UserSessionService } from "../user-session/user-session.service";
import { UtilsService } from "../utils/utils.service";
import { WebservicesService } from "../webservices/webservices.service";
import { Navigator } from "src/app/components/menu/navigator";
import { JurisdictionService } from "../geo/jurisdiction.service";
import { GeoResponse } from "src/app/interfaces/geo-interface";
import { delay, first, take } from "rxjs/operators";
import { AccountBalanceService } from "../balance/account-balance.service";
import { LobbyService } from "../lobby/lobby.service";
import { Router } from "@angular/router";
import { GamesService } from "../lobby/games.service";
import { IabControllerService } from "../iabController/iab-controller.service";

@Injectable()
export class GameHubControllerService {
  private gameLaunchingStrategies: any = {};
  private _instances: Array<any> = [];
  private focusedInstance: BehaviorSubject<any>;
  private launchStrategyType: string = "";
  private gameLaunched: boolean = false;

  constructor(
    public config: ConfigService,
    public userSessionService: UserSessionService,
    public webservices: WebservicesService,
    public events: EventsService,
    public platform: Platform,
    private utils: UtilsService,
    public gameHub: GameHub,
    private gameService: GamesService,
    private eventsService: EventsService,
    private jurisdiction: JurisdictionService,
    private navigator: Navigator,
    private accountBalanceService: AccountBalanceService,
    private lobbyService: LobbyService,
    private iabController:IabControllerService,
    public router: Router
  ) {
    const useInAppBrowser = this.config.isFeatureON(this.config.getConfig(), "FEATURE_USE_IN_APP_BROWSER", true);
    const inAppOrTab = useInAppBrowser ? this.launchMobileApps : this.launchInGameTab;
    this.gameLaunchingStrategies = {
      default: this.launchInGameTab,
      downloadable: this.launchInGameTab,
      mobileWebIos: this.launchInGameTab,
      mobileWebAndroid: this.launchInGameTab,
      mobile: inAppOrTab,
      mobileIos: inAppOrTab,
    };

    fromEvent(window, "message").subscribe((event: any) => {
      this.handleGameEvent(event);
    });

    this.focusedInstance = new BehaviorSubject(null);
  }

  launchCasinoGame(data: any) {
    // this.navigator.toLobby();
    console.log("Launching Casino Game");
    if (this.gameLaunched) return true;
    this.gameLaunched = true;
    setTimeout(() => (this.gameLaunched = false), 800);

    // KP  this.LobbyService.clearWaitingGameData();
    this.userSessionService
      .getCustomer()
      .pipe(take(1))
      .subscribe((customer: CustomerModel) => {
        let isMobileApp = ((this.getDeviceType() == "mobile" || this.getDeviceType() == "mobileIos") ? true : false);
        let model = new CasinoGameModel(
          data,
          this.config,
          customer,
          this.userSessionService,
          isMobileApp
        );

        this.killAllInstances();
        //this.launchGame(model); //v remove
        this.jurisdiction
          .verifyJurisdiction(() => this.launchCasinoGame(data))
          .then((geoResp: GeoResponse) => {
            this.events.publish("event:gameLaunched", {
              customer_id: customer.customerId,
              game_name: model.game_name,
              is_demo: false,
              game_id: data.id,
              game_order: data.game_order,
              keyword_name: data.keyword_name,
              gameUrl: data.gameUrl,
            });
            model.is_demo = false;
            this.launchGame(model);
          })
          .catch((err) => {
            console.log("launch aborted.", err);
          });
      });
  }

  launchGame(model) {
    this.lobbyService.setRestrictedGameData(model);
    this.events.publish("event:balanceState", { show: false, code: "IN_GAME" });
    const deviceType = this.getDeviceType();
    const featureConfig = this.config.getConfig().FEATURE_MOBILE_IFRAME_VENDORS;
    const iframeVendors = featureConfig ? JSON.parse(featureConfig) : [];
    let launchType = deviceType;
    const vendorId = model?.vendor_ident;
    if (this.platform.is("capacitor") && iframeVendors.includes(vendorId)) {
      launchType = "default";
    }
    if (launchType in this.gameLaunchingStrategies) {
      const launcherFn = this.gameLaunchingStrategies[launchType];
      launcherFn.apply(this, [model]);
    }
  }

  getDeviceType() {
    let deviceType = "default";
    if (this.platform.is("electron")) {
      deviceType = "downloadable";
    } else if (
      this.platform.is("mobileweb") &&
      !this.platform.is("capacitor") &&
      this.platform.is("ios")
    ) {
      deviceType = "mobileWebIos";
    } else if (
      this.platform.is("mobileweb") &&
      !this.platform.is("capacitor") &&
      this.platform.is("android")
    ) {
      deviceType = "mobileWebAndroid";
    } else if (this.platform.is("capacitor") && this.platform.is("ios")) {
      deviceType = "mobileIos";
    } else if (this.platform.is("capacitor")) {
      deviceType = "mobile";
    }
    console.log("Device type:", deviceType);
    return deviceType;
  }

  focusInstance(instance_id) {
    this.gameHub.focusInstance(instance_id);
    //let activeTab = this.app.getActiveNav().getActive().component.name;

    //let activeTab = this.app.getActiveNavs()[0].getActive().name;
    // let activeTab = this.app.getActiveNavs()[0].getActive().instance.lobbyNameParam;
    // console.log("ACTIVE TAB", activeTab);

    // get instance to determine how the game is loaded and how to brin git into focus
    let instance = this.gameHub.getInstance(instance_id);

    if (instance.viewContainer == "IFRAME") {
      //this.events.publish("action:changeTab", "game");
      this.navigator.toGametab();
      // this.navController.navigateForward('/main/casino/games');
      // if (activeTab == 'GAME_TABS') {
      //     this.focusedInstance.next(instance_id);
      // } else {

      //     this.eventsService.publish('event:gameHub:embedGame', { instanceId: instance_id });
      //     this.focusedInstance.next(instance_id);

      // }
      this.focusedInstance.next(instance_id);
    }
    this.gameHub.unHighlightInstance(instance_id);
    this.events.publish("event:mygames:unhighlight");
    this.gameHub.muteGames(instance_id);
  }
  unfocusAllInstances() {
    let instance = null;
    let instances = this.getAllInstances();
    if (Object.keys(instances).length) {
      for (var id in instances) {
        instance = this.getInstance(id);
        instance.isActive = false;
        this._instances[id] = instance;
      }
    }
  }
  handleGameEvent(event) {
    if (!isUndefined(event.data) && !isUndefined(event.data.name)) {
      // windowID maps to our gameHub instanceID
      let instance_id = event.data.windowID;
      let instance = this.gameHub.getInstance(instance_id);
      switch (event.data.name) {
        case "registerActivity":
          this.events.publish("event:inactivity:reset");
          break;
        case "close_game":
          this.removeInstance(instance_id);
          this.gameService.getRecentGames();
          this.eventsService.publish('event:tracker:gameClosed');
          // this.eventsService.unsubscribe('event:geoComply:present');
          // this.eventsService.unsubscribe('event:geoComply:dismiss');
          if (
            !isUndefined(event.data.closeCode) &&
            event.data.closeCode == "CLT_LOGOUT"
          ) {
            this.navigator.navigateTo(
              "LogoutPage",
              {},
              { code: "INACTIVITY", reason: "GAME_CLT_LOGOUT" }
            );
          } else {
            if(this.lobbyService.getCurrentActiveKeywordItem()){
              this.events.publish('event:select:active:keyword', this.lobbyService.getCurrentActiveKeywordItem());
            } else {
              this.navigator.toLobby();
            }
          }
          break;
        case "show_buy_chips":
          break;
        case "action_request":
        case "bet_request":
        case "insurance_request":
        case "post_ante_request":
        case "post_blind_request":
        case "player_timeout":
          let focusedInstanceId = this.gameHub.getFocusedInstance();
          if (instance_id !== focusedInstanceId) {
            this.events.publish("event:mygames:highlight");
            this.gameHub.highlightInstance(instance_id);
          }
          break;
      }
    }
  }

  getInstance(id) {
    return this._instances[id];
  }

  updateInstance(instance_id, instance) {
    this._instances[instance_id] = instance;
  }
  getLaunchStrategyType() {
    return this.launchStrategyType;
  }

  getAllInstances() {
    return this._instances;
  }
  getFocusedInstance() {
    return this.focusedInstance;
  }

  launchInGameTab = (model) => {
    const instanceId = this.gameHub.addCasinoGame(model, {
      viewContainer: "IFRAME",
    });

    this.events.subscribe("event:authentication:logout", () => {
      this.removeInstance(instanceId);
    });

    this.events.subscribe("event:game:close", () => {
      this.removeInstance(instanceId);
    });

    if (model.is_demo) {
      this.focusInstance(instanceId);
    } else {
      const obj: any = {
        customer_id: model.customer.customerId,
        session_token: this.userSessionService.getSessionToken(),
        game_launcher_id: "-1",
      };
      const game_lauch_time_out = this.platform.is('capacitor') ? 10 : 1000;
      this.webservices.post("games/close-game", obj).subscribe(() => {
        setTimeout(() => {
          this.focusInstance(instanceId);
        }, game_lauch_time_out);
      });
    }

    this.setLaunchStrategyType("launchInGameTab");

    //seo stuff:
    const gId = model.id;
    const externalLinksData = this.config.getExternalLinks();
    let link = externalLinksData.payload.filter((link) => link.code == gId);
    link = !!link.length ? link[0] : {};
  };

  async launchMobileApps(model: any) {
    const gamePrms: any = {
      gameLaunchId: model.id,
    };
    if (!model.is_demo && model.userSessionService?.sessionToken) {
      gamePrms.session_token = model.userSessionService.sessionToken;
      gamePrms.vendor_name = model.vendor_ident;
    }
    if (model.customer?.customerId) {
      gamePrms.customer_id = model.customer.customerId;
    }
    const deviceType = this.getDeviceType();
    const delayTime = 0;
   await this.closeAllGamesBeforeLaunch(model);
    this.webservices.getApiNoRedirect(model.url, deviceType, gamePrms)
      .pipe(delay(delayTime), first()).subscribe({
        next: (resp: any) => {
          if (resp?.result && resp.payload) {
            this.lobbyService.clearWaitingGameData();
            const url = resp.payload.href ?? resp.payload.src ?? '';
            if (url) {
              this.iabController.launchIAB(url, gamePrms);
            }
          }
        },
        error: (error) => {
          console.error("Error occurred:", error?.error_code);
          this.events.publish("event:balanceState", { show: true })
          if (error.error_code === "PLAYER_HAS_ACTIVE_BONUS_CANNOT_USED_BY_GAME") {
            localStorage.setItem('skipActiveBonusCheck', 'true');
            setTimeout(() => {
              this.navigator.openPopover('RestrictedMoneyPopover', { message: '' }, 'standard-popover levelup', false, true, true, -1, 'cover', true);
            }, 700);
          }
        }
      });
  }

  private closeAllGamesBeforeLaunch(model: any): Promise<boolean> {
    return new Promise((resolve) => {
      if (model?.is_demo) {
        return resolve(true);
      }
      const payload = {
        customer_id: model?.customer?.customerId,
        session_token: this.userSessionService.getSessionToken(),
        game_launcher_id: "-1",
      };

      this.webservices.post("games/close-game", payload).subscribe({
        next: () => resolve(true),
        error: () => resolve(true),
      });
    });
  }

  setLaunchStrategyType(val) {
    this.launchStrategyType = val;
  }

  public removeInstance(instance_id) {
    this.eventsService.publish("game:fullscreen:exit");

    if (!isUndefined(instance_id)) {
      const instance = this.gameHub.getInstance(instance_id);

      if (!isUndefined(instance)) {

        if (instance.model.getInstanceCategoryType() === "casino-game") {
          this.events.publish("event:balanceState", { show: true });
        }

        if (instance.viewContainer == "IFRAME") {
          this.events.publish("event:gameHub:removeGame", instance_id);
        }
        // remove from GameHub
        this.gameHub.removeInstance(instance_id);

        // Load next instance or just go back to Lobby
        const next_instance = this.gameHub.getNextInstance();

        if (next_instance > 0) {
          this.focusInstance(next_instance);
          const next_insatnce_model = this.gameHub.getInstance(next_instance);
          if (instance.viewContainer == "IFRAME") return this.navigator.toCasino();
          return
        }

        //return this.navigator.toCasino();
      }
    }
  }

  killAllInstances() {
    let instances = this.gameHub.getAllInstances();

    if (Object.keys(instances).length) {
      for (var id in instances) {
        this.killInstance(id);
      }
    }
  }

  killInstance(instance_id) {
    if (!isUndefined(instance_id)) {
      let instance = this.gameHub.getInstance(instance_id);
      if (!isUndefined(instance)) {
        if (instance.viewContainer == 'NEWWINDOW') {
          // in case the window is closed from x on the window
          if (instance.windowInstance) instance.windowInstance.close();
        }
        if (instance.viewContainer == "IFRAME") {
          this.events.publish("event:gameHub:removeGame", instance_id);
          if (instance.model.getInstanceCategoryType() === "casino-game") {
            this.events.publish("event:balanceState", { show: true });
          }
        }
        // remove from GameHub

        this.gameHub.removeInstance(instance_id);
      }
    }
  }

  public launchDailySpin(spins) {
    this.jurisdiction
      .verifyJurisdiction(() => this.launchDailySpin(spins))
      .then((geoResp: GeoResponse) => {
        return this.continueDailySpin(spins);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  private continueDailySpin(spins: any): any {
    this.navigator.navigateTo("DailySlotComponent", {
      forceModal: true,
      customModalClass: "custom-modal-class-transparent"
    },
      { availableSpins: spins });
  }

}
